import { render, staticRenderFns } from "./SelectionCancelled.vue?vue&type=template&id=6a28abe2"
import script from "./SelectionCancelled.vue?vue&type=script&lang=js"
export * from "./SelectionCancelled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports